import { humanize } from 'common/helpers/humanize';

function toSlug(str) {
  return String(str)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

function tryTranslate(t, i18n, namespace, key) {
  if (!key) return null;
  const translationKey = `${namespace}.${key}`;
  if (i18n && typeof i18n.exists === 'function' && i18n.exists(translationKey)) {
    return t(translationKey);
  }
  return null;
}

const COMPONENT_TYPE_NAMESPACES = [
  'diagnosticRules.form.componentSubtypeOptions',
  'assets.options.componentTypes',
  'machineBuilder.componentTypes',
];

function isNumericId(value) {
  return typeof value === 'number' || (typeof value === 'string' && /^\d+$/.test(value));
}

function translateFromNamespaces(t, i18n, key) {
  if (!key) return null;
  const keys = [key, toSlug(key)];
  for (let i = 0; i < COMPONENT_TYPE_NAMESPACES.length; i += 1) {
    for (let j = 0; j < keys.length; j += 1) {
      const translated = tryTranslate(t, i18n, COMPONENT_TYPE_NAMESPACES[i], keys[j]);
      if (translated) return translated;
    }
  }
  return null;
}

/**
 * Localized machine-builder / task-template component type label.
 *
 * @param {function} t - i18next `t`
 * @param {object} [i18n] - i18next instance (`exists` for key lookup)
 * @param {{ text?: string, name?: string, value?: string, component_type?: string, component_subtype?: string }} element - metadata option
 * @returns {string}
 */
export function getComponentTypeDisplayName(t, i18n, element) {
  if (!element) return '';

  const subtypeMatch = translateFromNamespaces(t, i18n, element.component_subtype);
  if (subtypeMatch) return subtypeMatch;

  const candidates = [element.text, element.name, element.value].filter(
    value => value != null && value !== '' && !isNumericId(value)
  );

  const templateMatch = candidates
    .map((key) => {
      const translated = tryTranslate(t, i18n, 'taskTemplates.componentTypes', key);
      if (translated) return translated;
      return tryTranslate(t, i18n, 'taskTemplates.componentTypes', toSlug(key));
    })
    .find(Boolean);
  if (templateMatch) return templateMatch;

  const namespaceMatch = candidates
    .map(key => translateFromNamespaces(t, i18n, key))
    .find(Boolean);
  if (namespaceMatch) return namespaceMatch;

  const typeMatch = translateFromNamespaces(t, i18n, element.component_type);
  if (typeMatch) return typeMatch;

  if (element.text || element.name) {
    return element.text || element.name;
  }

  if (element.value != null && !isNumericId(element.value)) {
    return humanize(element.value);
  }

  return '';
}
